import { Form } from "react-bootstrap";
import { BinIcon } from "../../../../components/icon/Icon";
import { LiteTradeSearchInputStyled } from "./styled/LiteTradeSearchInputStyled";
import { memo } from "react";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

function LiteTradeSearchInput(props) {
    const {className, itemRef, ...inputProps} = props;
    const {getLangPath} = useLangContext();
    return <LiteTradeSearchInputStyled className={className}>
        <Form.Control
            size="sm"
            type="text"
            name="asset-search"
            placeholder={getLangPath('lite_version.home.search')}
            ref={itemRef}
            {...inputProps}
        />
        <BinIcon name="IcSearch"/>
    </LiteTradeSearchInputStyled>
}

export default memo(LiteTradeSearchInput);
